import { safeGetFromLocalStorage } from "./safeJSONParse";

export const getModuleId = () => {
  const moduleObj = safeGetFromLocalStorage("module", null);
  return moduleObj?.id;
};
